module.exports = __webpack_public_path__ + "img/touxiang.0727b72c.png";